import request from 'api/request';

export default function sendFeedbackRoute({ ticketId, answers }) {
  return request({
    url: `/tickets/${ticketId}/feedback`,
    method: 'POST',
    data: { answers },
  });
}
